import dynamic from 'next/dynamic';

const Index = dynamic(() => import('@/Index'), { ssr: false });

const Component: React.FC = () => <Index />;

export default Component;
